import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useEffect, useRef, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { IPermissionProps } from "../../models/Login";
import { Dialog } from "primereact/dialog";
import { ITicketMast } from "../../models/TicketMast";

interface Iprops {
    singleData: ITicketMast,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void,
    setModal: (modal: any) => void,
    permissions?: IPermissionProps,
}

export const TicketHistory = (props: Iprops) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<any>, loading: boolean });
    const dt = useRef<any>(null);

    const loadTableData = async () => {
        setTableData({ tableData: [], loading: true });
        const response = await Fetch("Ticket/ticketHistory", "GET", null, `ticket_ID=${props.singleData.ticket_ID}`, props.toast);
        if (response) {
            const data: Array<any> = await response.json();
            setTableData({ tableData: data, loading: false });
        }
    }

    const onHide=()=>{
        props.hideDialog();
    }

    useEffect(()=>{
       if(props.open) loadTableData();
    },[props.open]);

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Add/Edit Ticket" modal className="p-fluid" onHide={onHide}>
            <p><b>Ticket ID:</b> {props.singleData.ticket_ID}</p>
            <p><b>Subject:</b> {props.singleData.ticket_Subject}</p>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                ref={dt} size="small" stripedRows scrollable scrollHeight="65vh"
                value={tableData.tableData}
                showGridlines responsiveLayout="scroll"
                loading={tableData.loading}
            >
                <Column header="Sr N" body={(data, options) => options.rowIndex + 1} style={{maxWidth: "3rem"}}/>
                <Column field="ticket_Status" header="Status" />
                <Column field="reason" header="Comment" />
                <Column field="createdOn" header="Date" body={(e)=><p>{e.createdOn.split("T")[0]}</p>} />
                <Column field="createdOn" header="Time" body={(e)=><p>{(Number(e.createdOn.split("T")[1].split(":")[0]) <= 12 ? Number(e.createdOn.split("T")[1].split(":")[0]) : Number(e.createdOn.split("T")[1].split(":")[0])-12 ) + ":"+e.createdOn.split("T")[1].split(":")[1]} {Number(e.createdOn.split("T")[1].split(":")[0]) < 12 ? "AM" : "PM"}</p>} />
            </DataTable>
            </Dialog>
    );
}